import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SideCollapseDirectiveSharedModule } from '@shared/core/directives/sideCollapse';

import { PickupAsapModule } from '../../components/pickupAsap';
import { PickupLabelModule } from '../../components/pickupLabel';
import { PickupLaterModule } from '../../components/pickupLater';
import { PickupNextModule } from '../../components/pickupNext';

import { PickupForFilterComponent } from './pickup-for-filter.shared.component';

@NgModule({
    declarations: [
        PickupForFilterComponent
    ],
    imports: [
        CommonModule,
        SideCollapseDirectiveSharedModule,

        PickupAsapModule,
        PickupLabelModule,
        PickupLaterModule,
        PickupNextModule,
    ],
    exports: [
        PickupForFilterComponent
    ],
})
export class PickupForFilterModule { }
